import { SimpleCard } from '@hivebrite/design-system/SimpleCard';

const NotFound = () => (
  <SimpleCard
    faIconProps={{
      iconName: 'cat-space',
    }}
    title={s__('Mentoring|Page not found')}
    description={s__('Mentoring|Sorry, this page was not found')}
  />
);

export default NotFound;
